module.exports = __webpack_public_path__ + "iconoAgenda512.png";